<template>
    <div class="cursor-pointer" @click.stop="click()">
        <div class="sprite-icons-expanded inline-block align-middle" :class="{'collapse': show}"></div>
        <div class="inline-block align-middle pl-2">{{ text }}</div>
        <m-slider :show="show">
            <slot></slot>
        </m-slider>
    </div>
</template>
<script>
export default {
    props: {
        text: String
    },
    data() {
        return {
            show: false
        }
    },
    methods: {
        click() {
            this.show = !this.show
            this.$emit('click', this.show)
        }
    }
}
</script>
<style lang="scss" scoped>
.collapse {
    transform: rotateZ(180deg);
}
</style>
